import { render, staticRenderFns } from "./Substrates.vue?vue&type=template&id=5f69c951&"
import script from "./Substrates.js?vue&type=script&lang=js&"
export * from "./Substrates.js?vue&type=script&lang=js&"
import style0 from "./Substrates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports